import './styles.scss'
import Close from '../../icons/Close'

const CloseButton = ({ onClose , size, classes}) => {
    return (
      <div className={`close-btn cursor-pointer ${classes}`} onClick={onClose}>
        <Close size={size}/>
      </div>
    );
  };

  export default CloseButton